import { Component, Input, OnInit } from '@angular/core';
import { PlateformeService } from '../../../services/plateforme/plateforme.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mclu-content-bloc-header',
  templateUrl: './content-bloc-header.component.html',
  styleUrls: ['./content-bloc-header.component.scss'],
})
export class ContentBlocHeaderComponent {

  @Input()
  public title: string;

  @Input()
  public icone: string;

  @Input()
  public contentIsValid = false;

  constructor(public plateforme: PlateformeService) { }

}
